import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Fac from '@/components/Fac.vue'
//import FacIndex from '../components/fac/Index.vue'
import Caseindex from '../components/fac/Caseindex.vue'
import Await from '../components/fac/await.vue'
import Offer from '../components/fac/Offer.vue'
import Rescue from '../components/fac/rescue.vue'
import Par from '../components/fac/Par.vue'
import Inf from '../components/fac/inf.vue'
import Finish1 from '../components/fac/finish.vue'
import FinishIndex1 from '../components/fac/FinishIndex.vue'
import FinishPar1 from '../components/fac/finishpar.vue'


import Lookinf from '../components/fac/Lookinf.vue'
import Alter from '../components/fac/alter.vue'
import Close from '../components/fac/close.vue';
import Resstep from '../components/fac/resstep.vue'
import Parcase from '../components/par/Parcase.vue'
import Parinf from '../components/par/Parinf.vue'


import Finish from '../components/finish/finish.vue'
import FinishIndex from '../components/finish/FinishIndex.vue'
import FinishPar from '../components/finish/finishpar.vue'


import Reg from '@/components/Reg.vue'
//import RegIndex from '../components/regulator/Index.vue'
import RegCaseindex from '../components/regulator/Caseindex.vue'
import RegAwait from '../components/regulator/await.vue'
import RegOffer from '../components/regulator/Offer.vue'
import RegRescue from '../components/regulator/rescue.vue'
import RegPar from '../components/regulator/Par.vue'
import RegLookinf from '../components/regulator/Lookinf.vue'
import RegResstep from '../components/regulator/resstep.vue'
import Regdr from '@/components/regulator/dr.vue'
import resstepGoing from '../components/regulator/resstepGoing.vue'
import Finish2 from '../components/regulator/finish.vue'
//import FinishIndex2 from '../components/regulator/FinishIndex.vue'
import FinishPar2 from '../components/regulator/finishpar.vue'
import undistributed from '../components/regulator/undistributed.vue'
import waitCase from '../components/regulator/waitCase'
import waitCaseSet from '../components/regulator/waitCaseSet.vue'

import Com from '@/components/com.vue'
import ComIndex from '@/components/cmd_center/Index.vue'
import ComCaseindex from '../components/cmd_center/Caseindex.vue'
import Comset from '@/components/cmd_center/set.vue'
import pact from '@/components/cmd_center/pact.vue'
import serve from '@/components/cmd_center/serve.vue'
import add from '@/components/cmd_center/add.vue'
import appcase from '@/components/cmd_center/appcase.vue'
import appcase2 from '@/components/cmd_center/appcase2.vue'
import ComAwait from '@/components/cmd_center/await.vue'
import ComOffer from '@/components/cmd_center/Offer.vue'
import ComRescue from '@/components/cmd_center/rescue.vue'
import ComPar from '@/components/cmd_center/Par.vue'
import ComLookinf from '@/components/cmd_center/Lookinf.vue'
import ComResstep from '@/components/cmd_center/resstep.vue'
// import ComParcase from '@/components/par/Parcase.vue'
// import ComParinf from '@/components/par/Parinf.vue'
import helpStart from '@/components/cmd_center/helpStart.vue'
import helpCompany from '@/components/cmd_center/helpCompany.vue'
import finishSure from '@/components/cmd_center/finishSure.vue'
import finishEnd from '@/components/cmd_center/finish.vue'
// import wListRegulators from '@/components/cmd_center/wListRegulators.vue'
// import wToService from '@/components/cmd_center/wToService.vue'
import finishDetails from '@/components/cmd_center/finishDetails.vue'
import finishDetails1 from '@/components/cmd_center/star/starsdetail.vue'  //星使详情


import aboutus from '@/components/aboutus.vue'
import contact from '@/components/contact.vue'
import dowapp from '@/components/dowapp.vue'
import feedback from '@/components/feedback.vue'
import league from '@/components/league.vue'
import news from '@/components/news.vue'
import stars from '@/components/stars.vue'

import newsDetail from '@/components/news/newsDetail.vue'
import newsDetail2 from '@/components/news/newsDetail2.vue'
import newsDetail4 from '@/components/news/newsDetail4.vue'
import newsDetail5 from '@/components/news/newsDetail5.vue'
import newsDetail3 from '@/components/news/newsDetail3.vue'

import insurer from '@/components/programme/insurer.vue'
import TravelAgency from '@/components/programme/TravelAgency.vue'
import Scenicspot from '@/components/programme/Scenicspot.vue'
import overseas from '@/components/programme/overseas.vue'

//2018-11-23
import commonPage from '@/views/commonPage'
import mainPase from '@/views/commonPage/mainPase'
import statistical from '@/views/commonPage/statistical'
//监管机构
import regulator from '@/views/regulator'
import mainPaseRegulator from '@/views/regulator/mainPase'

//指挥中心
import cmd_center from '@/views/cmd_center'
import mainPaseCmdcenter from '@/views/cmd_center/mainPase'
import monitoring from '@/views/cmd_center/monitoringCase'
import creatNav from '@/views/cmd_center/monitoringCase/creatNav'
import creatCase from '@/views/cmd_center/monitoringCase/creatCase'
import consultingCase from '@/views/cmd_center/monitoringCase/consulting'
import Offlinepolicy from '@/views/cmd_center/monitoringCase/Offlinepolicy'
import anjianList from '@/views/cmd_center/anjianList'
import anjianList2 from '@/views/cmd_center/anjianList2'
import chatRecord from '@/views/cmd_center/chatRecord'
import videoList from '@/views/cmd_center/videoList'
//地图
import mapRouter from '@/views/map'
import mapLayout from '@/views/map/layout'
import mapSmall from '@/views/map/smallMap'
import mapSearch from '@/views/map/searchMap'
import mapGps from '@/views/map/searchMapGPS'

import clickMap from '@/views/map/clickMap'
//维护子用户
import subuser from '@/views/subuser/subuser'
import phone from '@/views/phone/phone'


//2020.01.07
import createDetails from '@/views/commonPage/details/createDetails'
import caseDetails from '@/views/commonPage/details'
import searchCase from '@/views/cmd_center/search'






//拆分路由
import branch from './branch.js'
Vue.use(Router)

export default new Router({
	scrollBehavior(to, from, savedPosition) {
			return {x: 0,y: 0}
	},
	mode:'hash',
	routes: [{
			path: '/',
			name: 'Index',
			meta: {
				keepAlive: true
			},
			component: Index
		},
		{
			path: '/subuser',
			name: 'subuser',
			component: subuser
		},
		{
		    path:'/phone',
		    name:'phone',
		    component:phone
		},
		{
			path: '/map',
			name: 'map',
			meta: {
				keepAlive: true
			},
			component: mapRouter
		},
		{
			path: '/mapSearch',
			name: 'mapSearch',
			meta: {
				keepAlive: true
			},
			component: mapSearch
		},
		{
			path: '/mapGps',
			name: 'mapGps',
			meta: {
				keepAlive: true
			},
			component: mapGps
		},
    {
			path: '/clickMap',
			name: 'clickMap',
			meta: {
				keepAlive: true
			},
			component: clickMap
		},
		{
			path: '/mapLayout',
			name: 'mapLayout',
			meta: {
				keepAlive: true
			},
			component: mapLayout
		},
		{
			path: '/mapSmall',
			name: 'mapSmall',
			component: mapSmall
		},
		{
			path: '/aboutus',
			name: 'aboutus',
			meta: {
				keepAlive: true
			},
			component: aboutus
		}, {
			path: '/contact',
			name: 'contact',
			meta: {
				keepAlive: true
			},
			component: contact
		}, {
			path: '/dowapp',
			name: 'dowapp',
			meta: {
				keepAlive: true
			},
			component: dowapp
		}, {
			path: '/feedback',
			name: 'feedback',
			meta: {
				keepAlive: true
			},
			component: feedback
		}, {
			path: '/league',
			name: 'league',
			meta: {
				keepAlive: true
			},
			component: league
		},
		{
			path: '/news',
			name: 'news',
			meta: {
				keepAlive: true
			},
			component: news,
		},
		{
			path: '/newsDetail',
			name: 'newsDetail',
			component: newsDetail,
		},
		{
			path: '/newsDetail2',
			name: 'newsDetail2',
			component: newsDetail2,
		}, {
			path: '/newsDetail4',
			name: 'newsDetail4',
			component: newsDetail4,
		}, {
			path: '/newsDetail5',
			name: 'newsDetail5',
			component: newsDetail5,
		}, {
			path: '/newsDetail3',
			name: 'newsDetail3',
			component: newsDetail3,
		}, {
			path: '/stars',
			name: 'stars',
			meta: {
				keepAlive: true
			},
			component: stars
		},
		{
			path: '/insurer',
			name: 'insurer',
			meta: {
				keepAlive: true
			},
			component: insurer
		}, {
			path: '/TravelAgency',
			name: 'TravelAgency',
			meta: {
				keepAlive: true
			},
			component: TravelAgency
		}, {
			path: '/Scenicspot',
			name: 'Scenicspot',
			meta: {
				keepAlive: true
			},
			component: Scenicspot
		},
		{
			path: 'overseas',
			name: 'overseas',
			meta: {
				keepAlive: true
			},
			component: overseas
		},
		{
			path: '/commonPage',
			name: 'commonPage',
			component: commonPage,
			redirect: '/mainPase',
			children: [{
					path: '/',
					name: 'mainPase',
					component: mainPase,
				},
				{
					path: 'anjianList1',
					name: 'anjianList1',
					component: anjianList
				},
        {
					path: 'anjianList2',
					name: 'anjianList2',
					component: anjianList2
				},
				{
					path: 'caseindex',
					name: 'Caseindex',
					component: Caseindex,
					children: [{
							path: 'await',
							name: 'Await',
							component: Await,
						},
						{
							path: 'Finish1',
							name: 'Finish1',
							component: Finish1,
						},
						{
							path: 'offer',
							name: 'Offer',
							component: Offer,
						},
						{
							path: 'rescue',
							name: 'Rescue',
							component: Rescue,
						},
						{
							path: 'close',
							name: 'Close',
							component: Close,
						},
						{
							path: 'inf',
							name: 'Inf',
							component: Inf,
						},
						{
							path: 'lookinf',
							name: 'lookinf',
							component: Lookinf,
						},
						{
							path: 'alter',
							name: 'alter',
							component: Alter
						},
						{
							path: 'resstep',
							name: 'resstep',
							component: Resstep
						},
						{
							path: 'par',
							name: 'Par',
							component: Par,
							children: [{
								path: 'parcase',
								name: 'parcase',
								component: Parcase
							}, {
								path: 'parinf',
								name: 'parinf',
								component: Parinf
							}]
						},
						{
							path: 'finishpar1',
							name: 'FinishPar1',
							component: FinishPar1,
							children: [{
								path: 'finishparinf',
								name: 'Finishparinf',
								component: Parinf
							}]
						}
					]
				}
			]
		}, {
			path: '/regulator',
			name: 'regulator',
			component: regulator,
			redirect: 'mainPaseRegulator',
			children: [{
					path: '/',
					name: 'mainPaseRegulator',
					component: mainPaseRegulator,
				},
				{
					path: 'caseindex',
					name: 'RegCaseindex',
					component: RegCaseindex,
					children: [{
							path: 'statistical',
							name: 'statistical',
							component: statistical,
						},
						{
							path: 'Finish2',
							name: 'Finish2',
							component: Finish2,
						},
						{
							path: 'dr',
							name: 'Regdr',
							component: Regdr
						},
						{
							path: 'await',
							name: 'RegAwait',
							component: RegAwait,
						},
						{
							path: 'offer',
							name: 'RegOffer',
							component: RegOffer,
						},
						{
							path: 'rescue',
							name: 'RegRescue',
							component: RegRescue,
						},
						{
							path: 'lookinf',
							name: 'Reglookinf',
							component: RegLookinf,
						},
						{
							path: 'resstep',
							name: 'Regresstep',
							component: RegResstep
						},
						{
							path: 'resstepGoing',
							name: 'resstepGoing',
							component: resstepGoing
						},
						{
							path: 'undistributed',
							name: 'undistributed',
							component: undistributed
						},
            {
							path: 'waitCase',
							name: 'waitCase',
							component: waitCase
						},
            {
							path: 'waitCaseSet',
							name: 'waitCaseSet',
							component: waitCaseSet
						},
						{
							path: 'par',
							name: 'RegPar',
							component: RegPar,
							children: [{
								path: 'parcase',
								name: 'Regparcase',
								component: Parcase
							}]
						},
						{
							path: 'finishpar2',
							name: 'RegFinishPar2',
							component: FinishPar2,
							children: [{
								path: 'finishparinf',
								name: 'RegFinishparinf',
								component: Parinf
							}]
						}
					]
				}
			]
		}, {
			path: '/cmd_center',
			name: 'cmd_center',
			component: cmd_center,
			redirect: '/mainPaseCmdcenter',
			children: [
        {
					path: '/',
					name: 'mainPaseCmdcenter',
					component: mainPaseCmdcenter,
				},
        
        {
        	path: '/cmd_center/createDetails',
        	name: 'createDetails',
        	component: createDetails
        },
        {
        	path: '/cmd_center/caseDetails',
        	name: 'caseDetails',
        	component: caseDetails
        },
        {
        	path: '/cmd_center/searchCase',
        	name: 'searchCase',
        	component: searchCase
        },
				{
					path: '/monitoring',
					name: 'monitoring',
					component: monitoring,
				},
				{
					path: 'creatCase',
					name: 'creatCase',
					component: creatCase,
				},
				{
					path: 'callCase1',
					name: 'callCase1',
					component: appcase
				},
        {
					path: 'callCase2',
					name: 'callCase2',
					component: appcase2
				},
        {
          path: '/cmd_center/Offlinepolicy',
          name: 'Offlinepolicy',
          component: Offlinepolicy,
        },
				{
					path: '/creatNav',
					name: 'creatNav',
					component: creatNav,
					children: [

						{
							path: 'creatCase1',
							name: 'creatCase1',
							component: creatCase,
						},
						{
							path: 'callCase',
							name: 'callCase',
							component: appcase
						},
						{
							path: 'consultingCase',
							name: 'consultingCase',
							component: consultingCase,
						},
            
            
					]
				},
				{
					path: 'caseindex',
					name: 'ComCaseindex',
					component: ComCaseindex,
					children: [{
							path: 'finishDetails',
							name: 'finishDetails',
							component: finishDetails
						},
            {
							path: 'finishDetails1',
							name: 'finishDetails1',
							component: finishDetails1
						},
						{
							path: 'anjianList',
							name: 'anjianList',
							component: anjianList
						},
						{
							path: 'chatRecord',
							name: 'chatRecord',
							component: chatRecord
						},
						{
							path: 'videoList',
							name: 'videoList',
							component: videoList
						},
						{
							path: 'finishEnd',
							name: 'finishEnd',
							component: finishEnd
						}, 
            // {
						// 	path: 'wListRegulators',
						// 	name: 'wListRegulators',
						// 	component: wListRegulators
						// }, 
            // {
						// 	path: 'wToService',
						// 	name: 'wToService',
						// 	component: wToService
						// }, 
            
            {
							path: 'ComAwait',
							name: 'ComAwait',
							component: ComAwait
						},
						{
							path: 'ComAwait1',
							name: 'ComAwait1',
							component: ComAwait
						},
						{
							path: 'appcase',
							name: 'appcase',
							component: appcase
						},
						{
							path: 'offer',
							name: 'ComOffer',
							component: ComOffer,
						},
						{
							path: 'rescue',
							name: 'ComRescue',
							component: ComRescue,
						},
						{
							path: 'lookinf',
							name: 'Comlookinf',
							component: ComLookinf,
						},
						{
							path: 'resstep',
							name: 'Comresstep',
							component: ComResstep
						},
						{
							path: "helpStart",
							name: 'helpStart',
							component: helpStart
						},
						{
							path: 'helpCompany',
							name: 'helpCompany',
							component: helpCompany
						},
						{
							path: 'finishSure',
							name: 'finishSure',
							component: finishSure
						},
						{
							path: 'par',
							name: 'ComPar',
							component: ComPar,
							children: [{
								path: 'parcase',
								name: 'ComParcase',
								component: Parcase
							}, {
								path: 'parinf',
								name: 'ComParinf',
								component: Parinf
							}]
						}
					]
				}, {
					path: 'Comset',
					name: 'Comset',
					component: Comset,
					children: [{
						path: 'pact',
						name: 'pact',
						component: pact
					}, {
						path: 'serve',
						name: 'serve',
						component: serve
					}, {
						path: 'add',
						name: 'add',
						component: add
					}]
				}
			]
		},
		...branch
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js